import { render, staticRenderFns } from "./HomeData.vue?vue&type=template&id=8be29c8e&scoped=true"
import script from "./HomeData.vue?vue&type=script&lang=js"
export * from "./HomeData.vue?vue&type=script&lang=js"
import style0 from "./HomeData.vue?vue&type=style&index=0&id=8be29c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be29c8e",
  null
  
)

export default component.exports